import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const client = new ApolloClient({
  uri: "https://your-second-brain.com/graphql",
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
);
